import { RUN_STATUS, RUN_STATUS_TYPE } from "utils/constants/runs";


export default function RunStatus({ status }) {
    return <div className={`rounded-xl px-3 flex flex-col items-center justify-center ml-4 text-center text-base text-white ${status < RUN_STATUS.COMPLETED ? "bg-yellow-500" : status >= RUN_STATUS.EXCEPTION ? "bg-red-600" : "bg-green-600" }`}>
        {RUN_STATUS_TYPE[status]}
    </div>
}